export default __webpack_public_path__ + "static/scfxMb-db438ca3ea76f5b45c6bcdd0a2dd4c84.png";